// Predict the first N active turns from Charge Time (CT) and Speed.
//
// Each clocktick every unit gains CT equal to its Speed; a unit acts when
// CT >= 100. Higher CT acts first; ties break by unit order (the caller
// passes units already in that order: L1, R1, L2, R2, …). After acting we
// assume "move + act" (CT − 100, then capped to 60 if it would exceed 60) —
// the normal case, and what governs the following turns.
//
// This is a deterministic BASELINE: it assumes everyone starts at CT 0
// (real FFT randomizes initial CT) and ignores Haste/Slow. So it's an
// estimate of order, most accurate near the start.
//
// units: [{ speed, ... }] in tie-break order. Returns the acting units (the
// same objects, so they carry display fields) in turn order; fast units
// repeat.
export function turnOrder(units, count = 12) {
  const state = units.map((src, i) => ({ src, order: i, ct: 0 }));
  const out = [];
  let guard = 0;
  while (out.length < count && guard < 100000) {
    guard++;
    for (const u of state) u.ct += u.src.speed || 0;
    // Resolve everyone who reached 100 this tick (highest CT first, then order).
    while (out.length < count) {
      const ready = state.filter((u) => u.ct >= 100).sort((a, b) => (b.ct - a.ct) || (a.order - b.order));
      if (!ready.length) break;
      const u = ready[0];
      out.push(u.src);
      let nc = u.ct - 100;
      if (nc > 60) nc = 60;
      u.ct = nc;
    }
  }
  return out;
}
